export default {
  title: 'Shanxi Installation Group Co., Ltd. - Investor Relations',
  home: {
    nav1: 'Investor Relations',
    nav2: 'information disclosure',
    nav3: 'Corporate Governance',
    nav4: 'Stock information',
    nav5: 'Investor Contact'
  },
  item1: {
    tit: 'Welcome to Shanxi Installation Group Co., Ltd. Investor Relations',
    txt: 'We are an engineering service provider headquartered in Taiyuan, Shanxi Province, China. We are engaged in professional industrial engineering, professional supporting engineering, other engineering and non engineering businesses. According to Frost Sullivan, based on revenue in 2022, we rank first among over 500 professional industrial engineering contractors in Shanxi Province and fifth among over 10000 professional industrial engineering contracting companies in China.',
    txt1: '2022 income of professional industrial engineering contractors in Shanxi Province',
    txt2: 'Income of China Industrial Engineering Contract Contracting Company in 2022'
  },
  item2: {
    tit1: 'prospectus supplement',
    tit2: 'Announcement Circular',
    tit3: 'Performance report',
    strDate: 'Start date',
    endDate: 'End date',
    input: 'Please enter keywords',
    all: 'total',
    txt: 'Data'
  },
  item3: {
    tit1: 'overview',
    tit2: 'Governance documents',
    tit3: 'Management team'
  },
  item4: {
    tit1: 'address',
    tit2: 'Phone/Fax',
    tit3: 'zip code',
    txt: 'No. 8 Xinhua Road, Tanghuai Industrial Park, Shanxi Transformation Comprehensive Reform Demonstration Zone, Shanxi Province, China'
  },
  item5: {
    tit1: '分时K线',
    tit2: '日K线图',
    tit3: '周K线图',
    tit4: '月K线图'
  }
}
